import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type ResearchCapability = "read" | "author" | "review" | "publish" | "manage";

export function useResearchCapability(capability: ResearchCapability) {
  return useQuery({
    queryKey: ["research_capability", capability],
    queryFn: async () => {
      const { data, error } = await supabase.rpc("has_research_capability", { _capability: capability });
      if (error) throw error;
      return Boolean(data);
    },
    staleTime: 5 * 60 * 1000,
  });
}
